<template>
    <div v-bind:class="{show : dialogueVisible == true, displayblock : dialogueVisible == true}" class="modal sustainable-component update-developmentblock" tabindex="-1" v-bind:id="'customModal' + getId()" role="dialog">
        <div class="modal-dialog" v-bind:class="size" role="document">
            <div class="modal-content">
                <div class="modal-header bg-primary">
                    Hantera
                </div>

                <div class="modal-body pb-0">
                    <v-form v-model="valid" ref="form">
                        <div class="container-fluid">
                            <div class="col-12">
                                <v-text-field v-bind:disabled="disabled" :rules="[rules.integer]" bg-color="white" name="jobBlockNumber"
                                              id="jobBlockNumber"
                                              :type="'text'"
                                              v-bind:label="$t('workorganisation_tab4_tool_create_block_nr')"
                                              variant="outlined"
                                              v-model="blockNumber">
                                </v-text-field>
                            </div>
                            <div class="col-12">
                                <v-text-field v-bind:disabled="disabled" :rules="[rules.required]" bg-color="white" name="jobBlockName"
                                              id="jobBlockName"
                                              :type="'text'"
                                              v-bind:label="$t('workorganisation_tab4_tool_create_block_name')"
                                              variant="outlined"
                                              v-model="blockName">
                                </v-text-field>
                            </div>
                        </div>
                    </v-form>
                </div>

                <div class="modal-footer pt-2 pb-1">
                    <v-btn color="blue-darken-1"
                           variant="text"
                           @click="close">
                        Stäng
                    </v-btn>
                    <v-btn v-bind:disabled="disabled" color="blue-darken-1"
                           variant="text"
                           @click="save">
                        Spara
                    </v-btn>
                </div>
            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>

<script>

    import ValidationService from "../../Services/ValidationService";
    import WorkOrganisationService from "../../Services/WorkOrganisationService";
    import CommonSpinner from '../../common/common-spinner.vue'
    //import CommonMCEEditor from '../../common/common-mce-editor.vue'
    import { getCurrentInstance } from 'vue'
    import { ref } from 'vue'
    const form = ref(null);

    export default {
        emits: ['updated'],
        name: 'update-developmentblock',
        props: {
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        components: {
            CommonSpinner,
        },
        methods: {
            changedRequirements(v) {
                this.educationAndRequirements = v;
            },
            getId() {
                return getCurrentInstance().uid;
            },
            close() {
                this.blockId = -1;
                this.blockNumber = -1;
                this.blockName = "";
                this.dialogueVisible = false;
                this.thisModal.hide();
            },
            async save() {
                var result = await this.form.validate();
                if (result.valid != true)
                    return;

                await WorkOrganisationService.updateBlock(this.blockId, this.blockName, this.blockNumber);

                this.$emit("updated"); 

                this.thisModal.hide();
            },
            open(item) {
                this.blockId = item.Id;
                this.blockNumber = item.BlockNumber;
                this.blockName = item.Name;
                this.thisModal.show();
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },
        data() {
            return {
                rules: ValidationService.rules(),
                dialogueVisible: false,
                blockId: -1,
                blockNumber: -1,
                blockName:'',
                thisModal: {},
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {

        },
        mounted() {
            this.$el.remove();
            document.body.appendChild(this.$el);

            // eslint-disable-next-line
            this.thisModal = new bootstrap.Modal(document.getElementById('customModal' + this.getId()), {});

            //window.emitter.on('display_login', this.close);
        },

        // eslint-disable-next-line
        setup(props, { emit }) {
            return { form }
        }

    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .modal-content{
        border-radius:unset;
    }

    .modal-footer {
        border-top-color: transparent;
    }
    .modal-header {
        border-top-left-radius: unset;
        border-top-right-radius:unset;
    }
</style>
